import { render, staticRenderFns } from "./HotelList.vue?vue&type=template&id=168e0701&scoped=true&"
import script from "./HotelList.vue?vue&type=script&lang=js&"
export * from "./HotelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168e0701",
  null
  
)

export default component.exports